import { Controller, useFormContext } from "react-hook-form";

export default function ControlledFormField({
  label,
  name,
  Component,
  defaultValue,
  rules,
  ...props
}) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        return <Component {...field} name={name} label={label} error={error?.message} {...props} />;
      }}
    />
  );
}
